"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IngestChunkedDocumentResultSchema = exports.IngestDocumentResultSchema = void 0;
const zod_1 = require("zod");
const document_specifications_1 = require("./document-specifications");
const search_providers_1 = require("./search-providers");
exports.IngestDocumentResultSchema = zod_1.z.object({
    wasAlreadyIndexed: zod_1.z.boolean(),
    chunksIndexed: zod_1.z.number(),
    documentSpec: document_specifications_1.DocumentEmbeddingSpecificationSchema,
    searchProvider: search_providers_1.SearchProviderNameSchema,
});
exports.IngestChunkedDocumentResultSchema = zod_1.z.object({
    wasAlreadyIndexed: zod_1.z.boolean(),
    chunksIndexed: zod_1.z.number(),
    documentSpec: document_specifications_1.DocumentChunkingSpecificationSchema,
    indexName: zod_1.z.string(),
    searchProvider: search_providers_1.SearchProviderNameSchema,
});
//# sourceMappingURL=ingestion-results.js.map